// ICE COLD — footer motion: scroll-linked reveal of the wordmark and centre content,
// magnetic pills on pointer devices, back to top.
(() => {
  const curtain = document.querySelector('[data-ice-footer]');
  if (!curtain) return;
  const footer = curtain.querySelector('.ice-footer');
  const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const clamp = (v) => Math.min(1, Math.max(0, v));

  curtain.querySelector('[data-top]')?.addEventListener('click', () => {
    window.scrollTo({ top: 0, behavior: reduced ? 'auto' : 'smooth' });
  });

  if (!reduced) {
    // Progress through the curtain: giant text from "top 80%" to the end, content from "top 40%".
    let queued = false;
    const update = () => {
      queued = false;
      const r = curtain.getBoundingClientRect();
      const vh = window.innerHeight;
      const end = vh - r.height;
      const giant = clamp((vh * 0.8 - r.top) / (vh * 0.8 - end || 1));
      const reveal = clamp((vh * 0.4 - r.top) / (vh * 0.4 - end || 1));
      footer.style.setProperty('--p-giant', giant.toFixed(3));
      footer.style.setProperty('--p-reveal', Math.min(1, reveal * 1.15).toFixed(3));
    };
    const queue = () => {
      if (!queued) {
        queued = true;
        requestAnimationFrame(update);
      }
    };
    new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        window.addEventListener('scroll', queue, { passive: true });
        queue();
      } else {
        window.removeEventListener('scroll', queue);
      }
    }).observe(curtain);
    window.addEventListener('resize', queue);
    update();
  }

  if (reduced || !matchMedia('(hover: hover) and (pointer: fine)').matches) return;

  curtain.querySelectorAll('[data-magnetic]').forEach((el) => {
    el.addEventListener('pointermove', (e) => {
      const r = el.getBoundingClientRect();
      const x = e.clientX - r.left - r.width / 2;
      const y = e.clientY - r.top - r.height / 2;
      el.classList.add('is-magnet');
      el.style.transform = `perspective(600px) translate(${x * 0.4}px, ${y * 0.4}px) rotateX(${-y * 0.15}deg) rotateY(${x * 0.15}deg) scale(1.05)`;
    });
    el.addEventListener('pointerleave', () => {
      el.classList.remove('is-magnet');
      el.style.transform = '';
    });
  });
})();
